import {useMsal} from "@azure/msal-react";
import {loginRequest} from "./authConfig";
import styled from "@emotion/styled/macro";



const AdLoginSection = styled.section`
    text-align:center;
button {
    padding:3em 10em 3em 10em;
    font-size:x-large;
    
}
`
const AzureAdLogin: React.FC<{}> = (props) => {
    const { instance } = useMsal();
    const handleLogin = () => {
        instance.loginPopup(loginRequest).catch(e => console.log(e));
    }
    return <AdLoginSection><button onClick={() => handleLogin()}>Login</button></AdLoginSection>;

}
export default AzureAdLogin;